module.exports = __webpack_public_path__ + "img/bguc-360-room-1-hires.7f0d46f8.jpg";